import Colors from '../../../../themes/Colors';
import React from 'react'
import { Icon, Dropdown, Menu } from 'antd'

// Actions dropdown ("more" kebab) for a table row. Reuses the same menuItems
// shape as the cards: { key, label, disabled, onClick }.
const RowActions = ({ items = [] }) => {
  if (!items.length) return null

  const overlay = (
    <Menu>
      {items.map((item) => (
        <Menu.Item
          key={item.key}
          disabled={item.disabled}
          onClick={item.disabled ? undefined : item.onClick}
        >
          {item.label}
        </Menu.Item>
      ))}
    </Menu>
  )

  return (
    <Dropdown overlay={overlay} trigger={['click']}>
      <Icon
        type="more"
        style={{ cursor: 'pointer', fontSize: 18, color: Colors.textMuted }}
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  )
}

export default RowActions
